import './_edit-sort.js'
import './_edit-crop.js'
import './_edit-select.js'
//  ######             ####   #####   ##   ##  ##     ##  ######
//    ##              ##     ##   ##  ##   ##  ####   ##    ##
//    ##    ########  ##     ##   ##  ##   ##  ##  ## ##    ##
//    ##              ##     ##   ##  ##   ##  ##    ###    ##
//    ##               ####   #####    #####   ##     ##    ##
/*
// 入力された文字数を表示する
<div class="js-textCount">
    <input name="" type="text" value="" placeholder="" class="js-textCount" data-text-count-max="30">
    <span class="js-textCount-output">-</span>
</div>
*/
/**
 * 文字数をカウントして返す
 * @param {string} text 文字列
 * @returns
 */
function textCount(text) {
  const segmenter = new Intl.Segmenter('ja', { granularity: 'grapheme' })
  return [...segmenter.segment(text)].length
}
// 入力時の実行
window.addEventListener('input', function (e) {
  const item = e.target.closest('.js-textCount')
  if (!item) {
    return
  }
  applyTextCount(item)
})
// アクセス時の実行
const textCountList = document.getElementsByClassName('js-textCount')
for (const item of textCountList) {
  applyTextCount(item)
}
// 反映処理
function applyTextCount(item) {
  const input = item.querySelector('[data-text-count-max]')
  const targetList = item.querySelectorAll('.js-textCount-output')
  if (input) {
    const max = parseInt(input.dataset.textCountMax, 10)
    let min = 0
    if (input.dataset.textCountMin) {
      min = parseInt(input.dataset.textCountMin, 10)
    }
    const count = textCount(input.value)

    let text = count
    if (count > max || (min !== 0 && count < min)) {
      text = '<span style="color:red">' + text + '</span>'
    }

    for (const target of targetList) {
      target.innerHTML = text
    }
  }
}

window.textCount = function () {
  const itemList = document.querySelectorAll('.js-textCount')
  for (const item of itemList) {
    applyTextCount(item)
  }
}

/*
  ######          ######## ##     ##  ######  ##
 ##               ##         ## ##   ##       ##
 ##       ####### ######      ###    ##       ##
 ##               ##         ## ##   ##       ##
  ######          ######## ##     ##  ######  ########

// クリックされたとき、属するグループのクラスを非アクティブにし、指定ターゲットだけアクティブにする
<button type="button" class="js-clickExclActive" data-excl-group="hogeGroup" data-excl-target="fugaTarget"></button>
<div class="js-clickExclActive-group--hogeGroup js-clickExclActive-target--fugaTarget"></div>
*/
if (document.getElementsByClassName('js-clickExclActive')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-clickExclActive')) {
      return
    }
    const group = e.target.dataset.exclGroup
    const target = e.target.dataset.exclTarget

    if (e.target.classList.contains('js-clickExclActive-toggle') && e.target.classList.contains('active')) {
      // アクティブなボタンがトグルされた場合は全解除
      exclActive(group, '', 'active')
    } else {
      exclActive(group, target, 'active')
    }
  })
}
function exclActive(group, target, className = 'active') {
  const hide = document.getElementsByClassName('js-clickExclActive-group--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.remove(className)
  }
  const view = document.getElementsByClassName('js-clickExclActive-target--' + target)
  for (let index = 0; index < view.length; index++) {
    view[index].classList.add(className)
  }
}

/*
  ######          ########  #######   ######    ######   ##       ########
 ##                  ##    ##     ## ##        ##        ##       ##
 ##       #######    ##    ##     ## ##   #### ##   #### ##       ######
 ##                  ##    ##     ## ##    ##  ##    ##  ##       ##
  ######             ##     #######   ######    ######   ######## ########
// クリックされたとき、属するグループのクラスを反転させる
<button type="button" class="js-clickToggle" data-toggle-group="hogeGroup"></button>
<div class="js-clickToggle--hogeGroup"></div>

*/
if (document.getElementsByClassName('js-clickToggle')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-clickToggle')) {
      return
    }
    const group = e.target.dataset.toggleGroup
    toggleGroup(group, 'active')
  })
}

function toggleGroup(group, className = 'active') {
  const hide = document.getElementsByClassName('js-clickToggle--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.toggle(className)
  }
}

//  ######  #####  ##    ##  ######             ####  ##    ##  ##     ##   ####
//    ##    ##      ##  ##     ##              ##      ##  ##   ####   ##  ##
//    ##    #####    ####      ##    ########   ###     ####    ##  ## ##  ##
//    ##    ##      ##  ##     ##                 ##     ##     ##    ###  ##
//    ##    #####  ##    ##    ##              ####      ##     ##     ##   ####
/*
テキストを同期する
*/

window.addEventListener('input', function (e) {
  const item = e.target.closest('.js-textSync')
  if (!item) {
    return
  }

  const target = item.dataset.textSync
  document.querySelector('.js-textSync--' + target).innerText = item.value
})

//   ####  ##   ##  ##  #####  ######
//  ##     ##   ##  ##  ##       ##
//   ###   #######  ##  #####    ##
//     ##  ##   ##  ##  ##       ##
//  ####   ##   ##  ##  ##       ##
// 入力欄のレイアウトを切り替える
// 独自プルダウンから遠隔操作するためクリックイベントで発火させる
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-editShift')
  if (!item) {
    return
  }
  applyEditShift(item)
})

window.editShift = function () {
  const shiftList = document.querySelectorAll('.js-editShift')
  for (const item of shiftList) {
    console.log(item)
    applyEditShift(item)
  }
}
window.editShift() // レイアウト変更

function applyEditShift(item) {
  const target = item.dataset.target
  const group = item.value
  let swapDOM = null // 移動する必要があるDOM
  let swapDOMFrame = null // 移動するDOMのフレーム

  const targetList = document.querySelectorAll('.js-editShift--' + target)
  for (const target of targetList) {
    if (target.classList.contains('js-editShift-group--' + group)) {
      target.style.display = ''

      swapDOMFrame = target.querySelector('.js-editShift-swapArea')
    } else {
      target.style.display = 'none'
    }
    const itemDOM = target.querySelector('.js-editShift-swap')
    if (itemDOM) {
      swapDOM = itemDOM
    }
  }

  // 移動するDOMを適用する
  if (swapDOMFrame) {
    swapDOMFrame.appendChild(swapDOM)
  }
}

//  ####     #####   ###    ###              ###    ####    ####
//  ##  ##  ##   ##  ## #  # ##             ## ##   ##  ##  ##  ##
//  ##  ##  ##   ##  ##  ##  ##  ########  ##   ##  ##  ##  ##  ##
//  ##  ##  ##   ##  ##      ##            #######  ##  ##  ##  ##
//  ####     #####   ##      ##            ##   ##  ####    ####
/*
要素の追加
<?php
$groupID = '111'; // グループごとのユニークID
?>
<button type="button" class="js-addDOM" data-add-dom-type="【増やすHTMLの名称（blockなど）】" data-add-dom-target="<?php echo $groupID; ?>" data-add-dom-pos="start">
    先頭に追加
</button>
<div class="js-addDOM--<?php echo $groupID; ?>">
HTMLを追加するエリア
</div>
<button type="button" class="js-addDOM" data-add-dom-type="【増やすHTMLの名称（blockなど）】" data-add-dom-target="<?php echo $groupID; ?>" data-add-dom-pos="end">
    後尾に追加
</button>


ページ下部にベースのHTMLをストックしておく
<?php
$stock = '【増やすHTML】';
stockSetting($stock, '-【増やすHTMLの名称（blockなど）】');
?>
*/
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-addDOM')
  if (!item) {
    return
  }
  applyAddDOM(item)
})

function applyAddDOM(item) {
  const type = item.dataset.addDomType
  const target = item.dataset.addDomTarget
  const pos = item.dataset.addDomPos

  const targetArea = document.querySelector('.js-addDOM--' + target)

  let targetItemCount = 0 // 元々のアイテム数
  if (targetArea.children) {
    targetItemCount = targetArea.children.length + 1
  }
  // console.log(targetArea)
  // console.log(targetArea.children)

  // ストック用の変数からHTML取得
  let html = document.querySelector('.js-addDOM-item--' + type).value

  html = html.replace(/◆textarea◆/g, 'textarea') // textareaタグを元に戻す

  // 乱数生成
  const random = Math.ceil(Math.random() * 10000000)

  // 固有のIDが必要な箇所を置換する
  html = html.replace(/○○○/g, 'group_' + random)
  html = html.replace(/□□□/g, 'block_' + random)
  html = html.replace(/\[count\]/g, targetItemCount)

  // HTMLをDOMに変換
  const dom = html2dom(html)

  if (pos === 'start') {
    targetArea.insertBefore(dom, targetArea.firstChild) // 最初の子要素として追加
  } else {
    targetArea.appendChild(dom) // 最後の子要素として追加
  }

  window.selectSetup() // セレクトボックスの初期化
  window.sortSetup() // 並び替え処理の初期化
  window.changeSetup() // 入力系のセットアップ
  window.setWysiwyg() // エディタセットアップ
  window.editShift() // レイアウト変更
  window.exitAlert() // 離脱確認を予約する
  window.setCalender() // カレンダーを設定
}

/**
 * HTMLテキストをDOMに変換して返す
 * @param {string} html HTMLタグ　親が単一のタグであること
 * @returns DOM
 */
function html2dom(html) {
  const dom = document.createElement('div')
  dom.innerHTML = html

  return dom.firstElementChild
}

//  ####     #####   ###    ###            ####    #####  ##
//  ##  ##  ##   ##  ## #  # ##            ##  ##  ##     ##
//  ##  ##  ##   ##  ##  ##  ##  ########  ##  ##  #####  ##
//  ##  ##  ##   ##  ##      ##            ##  ##  ##     ##
//  ####     #####   ##      ##            ####    #####  ######
/*
.js-delDOMを押すと親の.js-delDOM-frameを消す
<div class="js-delDOM-frame">
  <button type="button" class="js-delDOM">
    削除
  </button>
</div>
*/
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-delDOM')
  if (!item) {
    return
  }
  applyDelDOM(item)
})

function applyDelDOM(item) {
  const target = item.closest('.js-delDOM-frame')
  const type = item.dataset.type

  let confirm
  if (type === 'reviewed') {
    confirm = window.confirm('審査済を選択するとリストから削除されます')
  } else {
    confirm = window.confirm('削除してよろしいですか？')
  }
  if (confirm) {
    target.parentNode.removeChild(target)
    window.checkCountDOM() // 数えるDOMの確認
    window.exitAlert() // 離脱確認を予約する
  }
}
//           ##        ###     ####  ######
//           ##       ## ##   ##       ##
//  ######## ##      ##   ##   ###     ##
//           ##      #######     ##    ##
//           ######  ##   ##  ####     ##
/*
.js-delDOMを押すと親の.js-delDOM-frameを消す
<div class="js-delDOM--hoge">
</div>
<button type="button" class="js-delDOM" data-del-target="hoge">
  削除
</button>
*/
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-delLastDOM')
  if (!item) {
    return
  }
  const name = item.dataset.delTarget
  applyDelLastDOM(name)
})

function applyDelLastDOM(name) {
  const target = document.querySelector('.js-delLastDOM--' + name + '>*:last-child')

  if (!target) {
    return
  }

  const confirm = window.confirm('削除してよろしいですか？')
  if (confirm) {
    target.parentNode.removeChild(target)
    window.checkCountDOM() // 数えるDOMの確認
    window.exitAlert() // 離脱確認を予約する
  }
}

//  #####   #####   #####    ###    ###             ####  ##      #####    ###    #####
//  ##     ##   ##  ##  ##   ## #  # ##            ##     ##      ##      ## ##   ##  ##
//  #####  ##   ##  #####    ##  ##  ##  ########  ##     ##      #####  ##   ##  #####
//  ##     ##   ##  ##  ##   ##      ##            ##     ##      ##     #######  ##  ##
//  ##      #####   ##   ##  ##      ##             ####  ######  #####  ##   ##  ##   ##
/*
.js-delDOMを押すと親の.js-delDOM-frameを消す
<div class="js-delDOM-frame">
  <button type="button" class="js-delDOM">
    削除
  </button>
</div>
*/
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-formClear')
  if (!item) {
    return
  }
  applyFormClear(item)
})

function applyFormClear(item) {
  const confirm = window.confirm('この求人情報をクリアしてよろしいですか？')
  if (!confirm) {
    return
  }

  const target = item.closest('.js-formClear-frame')

  // カスタムプルダウンを未選択にする
  const pulldownList = target.querySelectorAll('.custom-option:first-child')
  for (const element of pulldownList) {
    element.click()
  }

  const inputList = target.querySelectorAll('input,textarea,select,.js-customFile-preview')
  for (const input of inputList) {
    if (input.classList.contains('js-customFile-preview')) {
      // 画像トリミングのプレビューを外す
      input.src = ''
      continue
    }
    input.value = ''
    if (input.tagName === 'SELECT') {
      input.click()
    }
  }
  const delDOMlist = document.querySelectorAll('.js-delDOM-frame')
  for (const element of delDOMlist) {
    element.parentNode.removeChild(element)
    window.checkCountDOM() // 数えるDOMの確認
  }
}

//
//   ####  #####             ####    #####  ##
//  ##     ##  ##            ##  ##  ##     ##
//   ###   #####   ########  ##  ##  #####  ##
//     ##  ##                ##  ##  ##     ##
//  ####   ##                ####    #####  ######
//
/*<div class="js-delDOM-frame">
  <button type="button" class="js-delDOM">
    削除
  </button>
</div>
*/
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-delDOM-flow')
  if (!item) {
    return
  }
  applyDelDOMFlow(item)
})

function applyDelDOMFlow(item) {
  const target = document.getElementById('js-delDOM-frame')
  console.log(target)
  const confirm = window.confirm('削除してよろしいですか？')
  if (confirm) {
    target.remove()
  }
}

//  ######  #####  ##    ##  ######            ####    #####  ##
//    ##    ##      ##  ##     ##              ##  ##  ##     ##
//    ##    #####    ####      ##    ########  ##  ##  #####  ##
//    ##    ##      ##  ##     ##              ##  ##  ##     ##
//    ##    #####  ##    ##    ##              ####    #####  ######
/*
テキストをクリアする
<textarea name="text1"></textarea>
<button data-del-text-name="text1">削除</button>
*/
window.addEventListener('click', function (e) {
  const item = e.target.closest('button[data-del-text-name]')
  if (!item) {
    return
  }
  applyDelText(item)
})

function applyDelText(item) {
  const name = item.dataset.delTextName

  const confirm = window.confirm('入力テキストを削除してよろしいですか？')
  if (confirm) {
    const input = document.querySelector('[name="' + name + '"]')
    if (input) {
      input.value = ''
      input.focus()
    }
  }
}

//  ####     #####   ###    ###             ####   #####   ##   ##  ##     ##  ######
//  ##  ##  ##   ##  ## #  # ##            ##     ##   ##  ##   ##  ####   ##    ##
//  ##  ##  ##   ##  ##  ##  ##  ########  ##     ##   ##  ##   ##  ##  ## ##    ##
//  ##  ##  ##   ##  ##      ##            ##     ##   ##  ##   ##  ##    ###    ##
//  ####     #####   ##      ##             ####   #####    #####   ##     ##    ##
/*
DOMの数を数えて反応を返す

<button type="button" class="js-countDOM js-countDOM-toggle--<?php echo $groupID; ?>" data-count-dom-target="<?php echo $groupID; ?>" data-count-dom-max="10">
<span class="js-countDOM-view--<?php echo $groupID; ?>"></span>
</button>
<div class="js-countDOM--<?php echo $groupID; ?>">

</div>

*/
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-countDOM')
  if (!item) {
    return
  }
  setTimeout(() => {
    applyCountDOM(item)
  }, 100)
})
// アクセス時の実行
window.checkCountDOM = function () {
  const domCountList = document.getElementsByClassName('js-countDOM')
  for (const item of domCountList) {
    setTimeout(() => {
      applyCountDOM(item)
    }, 100)
  }
}
window.checkCountDOM() // 数えるDOMの確認
function applyCountDOM(item) {
  const target = item.dataset.countDomTarget
  const max = parseInt(item.dataset.countDomMax, 10)

  console.log(max)

  const itemList = document.querySelectorAll('.js-countDOM--' + target + '>*')
  const itemCount = itemList.length

  const viewList = document.querySelectorAll('.js-countDOM-view--' + target)
  for (const element of viewList) {
    element.innerText = itemCount + '/' + max
  }

  const toggleList = document.querySelectorAll('.js-countDOM-toggle--' + target)
  if (itemCount >= max) {
    for (const element of toggleList) {
      element.classList.add('is-disable')
    }
  } else {
    for (const element of toggleList) {
      element.classList.remove('is-disable')
    }
  }
}

//  #####   #####   #####    ###    ###            ####    #####  ##
//  ##     ##   ##  ##  ##   ## #  # ##            ##  ##  ##     ##
//  #####  ##   ##  #####    ##  ##  ##  ########  ##  ##  #####  ##
//  ##     ##   ##  ##  ##   ##      ##            ##  ##  ##     ##
//  ##      #####   ##   ##  ##      ##            ####    #####  ######

/*
<form action="./" method="get" onsubmit="return window.delConf()">
*/
window.delConf = function () {
  if (window.confirm('削除してよろしいですか？')) {
    return true
  } else {
    return false
  }
}

//   ####               ####  ##   ##  ##  #####  ######
//  ##                 ##     ##   ##  ##  ##       ##
//  ##  ###  ########   ###   #######  ##  #####    ##
//  ##   ##               ##  ##   ##  ##  ##       ##
//   ####              ####   ##   ##  ##  ##       ##
/*
.js-groupShiftをクリックすると「data-group-shift-target」から対象、「data-group-shift-direction」から【移動方向】を取得
「.js-groupShift--【対象】」内の「.js-groupShift-item」から「.active」または「.current」の付いたものを【移動方向】に入れ替え

<button type="button" class="js-groupShift" data-group-shift-target="【対象】" data-group-shift-direction="up">
</button>
<button type="button" class="js-groupShift" data-group-shift-target="【対象】" data-group-shift-direction="down">
</button>

<div class="js-groupShift--【対象】">
    <div class="js-groupShift-item">
    </div>
</div>
<div class="js-groupShift--【対象】">
    <div class="js-groupShift-item">
    </div>
</div>
*/

// ボタン操作による入れ替え
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-groupShift')
  if (!item) {
    return
  }

  setGroupShift(item)
})
function setGroupShift(item) {
  const direction = item.dataset.groupShiftDirection
  const target = item.dataset.groupShiftTarget

  const frameItemList = document.querySelectorAll('.js-groupShift--' + target)

  for (const frameItem of frameItemList) {
    groupShift(frameItem, direction)
  }
}

function groupShift(frameItem, direction = 'up') {
  if (frameItem.childElementCount < 2) {
    // アイテムが複数個なければキャンセル
    return
  }

  const itemList = frameItem.querySelectorAll('.js-groupShift-item')

  for (const item of itemList) {
    if (item.classList.contains('active') || item.classList.contains('current')) {
      itemSwap(frameItem, item, direction)
    }
  }
}

/**
 * 要素を上下どちらかの兄弟要素と入れ替える　入れ替え対象がなければ一周する
 * @param {element} frameItem 大枠の要素
 * @param {element} item 入れ替える要素
 * @param {string} direction 移動方向 up|down
 * @returns
 */
function itemSwap(frameItem, item, direction = 'up') {
  if (direction === 'up') {
    const shiftTarget = item.previousElementSibling // 上の兄弟要素を探す
    if (!shiftTarget) {
      // 兄弟要素がない
      frameItem.appendChild(item) // 一番下へ
    } else {
      frameItem.insertBefore(item, shiftTarget) // 上の兄弟要素と入れ替え
    }
  } else {
    const shiftTarget = item.nextElementSibling // 下の兄弟要素を探す
    if (!shiftTarget) {
      // 兄弟要素がない
      frameItem.prepend(item)
    } else {
      frameItem.insertBefore(shiftTarget, item) // 下の兄弟要素と入れ替え
    }
  }
}

//  #####    #####   ####  #####    ##   ##  ##  ######
//  ##  ##   ##     ##     ##  ##   ##   ##  ##    ##
//  #####    #####  ##     #####    ##   ##  ##    ##
//  ##  ##   ##     ##     ##  ##   ##   ##  ##    ##
//  ##   ##  #####   ####  ##   ##   #####   ##    ##

window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-recruitGroupName')
  if (!item) {
    return
  }
  applyRecruitGroupName(item)
})

function applyRecruitGroupName(item) {
  let type = item.querySelector('.js-recruitGroupName-type').value

  if (type === 'アルバイト・パート') {
    type = 'ア・パ'
  } else if (type === '') {
    type = '--'
  } else {
    type = type.substr(0, 1) // 先頭1文字を取る
  }

  let job = item.querySelector('.js-recruitGroupName-job').value
  if (job === '') {
    job = '-----------'
  }

  let name = type + '｜' + job

  const target = item.dataset.recruitGroupName

  const targetList = document.querySelectorAll('.js-recruitGroupName--' + target)
  for (const element of targetList) {
    element.innerHTML = name
  }
}

//  ##  ##     ##  #####   ##   ##  ######             ####  ##    ##  ##     ##   ####
//  ##  ####   ##  ##  ##  ##   ##    ##              ##      ##  ##   ####   ##  ##
//  ##  ##  ## ##  #####   ##   ##    ##    ########   ###     ####    ##  ## ##  ##
//  ##  ##    ###  ##      ##   ##    ##                 ##     ##     ##    ###  ##
//  ##  ##     ##  ##       #####     ##              ####      ##     ##     ##   ####
/*
入力欄の同期
<input type="text" class="js-inputSync js-inputSync--hoge" data-input-sync="hoge">
<input type="text" class="js-inputSync js-inputSync--hoge" data-input-sync="hoge">
*/
window.addEventListener('input', function (e) {
  const item = e.target.closest('.js-inputSync')
  if (!item) {
    return
  }
  window.inputSync(item)
})

window.inputSync = function (item) {
  const target = item.dataset.inputSync
  if (!target) {
    // データがなければ中止
    return
  }
  const value = item.value
  const inputList = document.getElementsByClassName('js-inputSync--' + target)
  for (const element of inputList) {
    element.value = value
  }
}

//    ###    ##      ##                 ####  ##   ##  #####   ####  ##  ##
//   ## ##   ##      ##                ##     ##   ##  ##     ##     ## ##
//  ##   ##  ##      ##      ########  ##     #######  #####  ##     ####
//  #######  ##      ##                ##     ##   ##  ##     ##     ## ##
//  ##   ##  ######  ######             ####  ##   ##  #####   ####  ##  ##
/*
同一グループすべてを切り替えるチェック
子孫、先祖グループまで辿れる
<input type="checkbox" name="all" class="js-allCheck" data-all-check-child="hoge">第1階層
<input type="checkbox" name="" class="js-allCheck js-allCheck--hoge js-allCheck-child " data-all-check-parent="hoge"  data-all-check-child="fuga">第2階層
<input type="checkbox" name="" class="js-allCheck--fuga js-allCheck-child " data-all-check-parent="fuga">第3階層
*/
if (document.getElementsByClassName('js-allCheck')[0]) {
  allCheck()
}
function allCheck() {
  // 親の切り替えを子に反映する
  window.addEventListener('change', function (e) {
    const item = e.target.closest('.js-allCheck')
    if (!item) {
      return
    }
    childUpdate(item)
    parentUpdate(item) // 親が複数あることを想定して親も更新する
  })
  // 子の状態を親に反映する
  window.addEventListener('change', function (e) {
    const item = e.target.closest('.js-allCheck-child')
    if (!item) {
      return
    }
    parentUpdate(item)
  })
  function childUpdate(item) {
    const checked = item.checked // 親のチェック状態取得
    const group = item.dataset.allCheckChild // 子グループ取得
    const checkChildList = document.getElementsByClassName('js-allCheck--' + group) // 子チェックボックス
    // 親のチェック状態を子に伝播させる
    for (const checkChild of checkChildList) {
      checkChild.checked = checked
      // 更に子がある場合は更に伝播
      if (checkChild.dataset.allCheckChild) {
        childUpdate(checkChild)
      }
    }
  }

  function parentUpdate(item) {
    const group = item.dataset.allCheckParent // 親グループ取得
    const checkList = document.getElementsByClassName('js-allCheck--' + group) // 子チェックボックス
    const checkListChecked = document.querySelectorAll('.js-allCheck--' + group + ':checked') // チェック済みの子
    const checkParentList = document.querySelectorAll('.js-allCheck[data-all-check-child="' + group + '"]') // 親チェック
    // 子チェック数とチェックされている子チェックの数の比較結果が解になる
    const result = checkList.length === checkListChecked.length

    // すべての親チェックに結果を反映する
    for (const checkParent of checkParentList) {
      checkParent.checked = result

      // 更に親がある場合は更に伝播
      if (checkParent.dataset.allCheckParent) {
        parentUpdate(checkParent)
      }
    }
  }
}
